import { motion } from 'framer-motion';

const ShowcaseSections = () => {
  const showcases = [
    {
      title: "Find",
      subtitle: "Great Wineries & Deals",
      description: "Discover great wineries in Napa Valley & Sonoma. App instantly finds great deals from wineries. Most wineries charge $5-$20 per person for wine tasting. This GPS enabled App instantly finds FREE Tastings, 2 for 1 Tastings and other deals closest to you.",
      image: "/images/showcase_1.png",
      reverse: false,
      bgClass: "bg-wine-900"
    },
    {
      title: "Snap",
      subtitle: "Photos & Share",
      description: "Check-in at a winery to earn rewards. Snap a photo and share directly via the app with all your friends & followers on Facebook, Twitter, and Instagram.",
      image: "/images/showcase_2.png",
      reverse: true,
      bgClass: "bg-muted/50"
    },
    {
      title: "Plan",
      subtitle: "Your Entire Trip",
      description: "Checkout large selection of Wineries, Hotels, Restaurants, Top 25 Wineries and Top 25 Things To Do to plan your entire trip. Make reservations, buy wines, and join wine clubs with just a tap!",
      image: "/images/ipad_showcase.png",
      reverse: false,
      bgClass: "bg-wine-900"
    }
  ];

  return (
    <>
      {showcases.map((showcase, index) => (
        <section 
          key={index}
          className={`relative ${showcase.bgClass} ${showcase.bgClass.includes('wine') ? 'text-white' : ''}`}
          data-testid={`showcase-section-${index}`}
        >
          <div className="max-w-7xl mx-auto">
            <div className={`flex flex-col lg:flex-row ${showcase.reverse ? 'lg:flex-row-reverse' : ''}`}>
              {/* Text Content - with horizontal padding */}
              <motion.div
                initial={{ opacity: 0, x: showcase.reverse ? 30 : -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="flex-1 min-w-0 flex flex-col justify-center py-10 sm:py-12 lg:py-16 px-4 sm:px-6"
              >
                <h2 className={`font-serif text-3xl sm:text-4xl md:text-5xl mb-3 sm:mb-4 ${showcase.bgClass.includes('wine') ? 'text-white' : 'text-primary'}`}>
                  {showcase.title} <span className={`italic ${showcase.bgClass.includes('wine') ? 'text-gold-400' : 'text-gold-600'}`}>{showcase.subtitle}</span>
                </h2>
                <p className={`text-base sm:text-lg leading-relaxed ${showcase.bgClass.includes('wine') ? 'text-white/80' : 'text-muted-foreground'}`}>
                  {showcase.description}
                </p>
              </motion.div>
              
              {/* Image - flush to section bottom with no padding */}
              <motion.div
                initial={{ opacity: 0, x: showcase.reverse ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="flex-1 min-w-0 flex justify-center lg:justify-end items-end px-4 sm:px-6 lg:px-0 lg:pr-6"
                style={{ marginBottom: '-2px' }}
              >
                <img 
                  src={showcase.image}
                  alt={`${showcase.title} ${showcase.subtitle}`}
                  className="w-auto max-w-full sm:max-w-[300px] lg:max-w-[380px] h-auto object-contain"
                />
              </motion.div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default ShowcaseSections;
